<div
  (click)="onLinkClick()"
  *ngIf="isUnlimitedTrialActive && daysLeft < 21"
  class="device-warning message-label"
>
  Pssst! You currently are on "Unlimited Clients Promo" plan for $29.99/Month.
  <span>
    <a routerLink="/pages/CalorieFriend/manage-subscription">
      You have <b>{{ daysLeft }} days</b> to update your payment information and
      keep this privilege.
    </a>
  </span>
</div>

<div
  (click)="(onlinkClick)"
  *ngIf="isUnlimitedTrial && daysLeft === 0"
  class="device-warning message-label"
>
  Your "Unlimited Clients Promo" subscriptions trial is expired and you have
  been reverted to the free plan.
  <span>
    <a routerLink="/pages/CalorieFriend/manage-subscription">
      Update your payment information to reactivate.
    </a>
  </span>
</div>


<div
  (click)="onLinkClick()"
  *ngIf="isFreePlan"
  class="device-warning message-label"
  style="cursor: pointer;"
>
  You are currently on the <b>Free Plan</b>, tap here to compares plans and upgrade.
</div>


<div
  (click)="onLinkClick()"
  *ngIf="isOnDemoOfferPlan"
  class="device-warning message-label"
  style="cursor: pointer;"
>
  You are currently on the <b>Pro Promo Plan</b>, tap here to compares plans and upgrade.
</div>



